import { FC } from 'react';
import { Tooltip as UITooltip } from '@/components/ui';
import { formatDistanceToNow } from 'date-fns';
import { MxmLead } from '../types';
import { LEAD_STATUS_COLORS, COLORS } from '../constants';

interface RecentLeadsListProps {
    leads: MxmLead[];
    recentLeads: MxmLead[];
}

export const RecentLeadsList: FC<RecentLeadsListProps> = ({ leads, recentLeads }) => {
    return (
        <div className="bg-white rounded-2xl p-6 border border-slate-100 h-[420px] flex flex-col">
            <div className="flex items-center justify-between mb-4">
                <UITooltip content="The latest leads that have entered your system and details on their current progress." position="right">
                    <h3 className="text-xs font-semibold text-slate-800">Recent Leads</h3>
                </UITooltip>
                <span className="text-[10px] text-slate-400">{leads.length} total</span>
            </div>
            {recentLeads.length > 0 ? (
                <div className="space-y-2">
                    {recentLeads.map((lead) => (
                        <div key={lead.id} className="flex items-center gap-3 py-2 border-b border-slate-50 last:border-0">
                            <div className="w-7 h-7 rounded-full bg-gradient-to-br from-indigo-100 to-purple-100 flex items-center justify-center text-[10px] font-bold text-indigo-600">
                                {lead.email?.charAt(0)?.toUpperCase() || '?'}
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className="text-xs font-medium text-slate-700 truncate">{lead.email}</p>
                                <p className="text-[10px] text-slate-400">{lead.attemptCount || 0} attempts • {formatDistanceToNow(new Date(lead.createdAt), { addSuffix: true })}</p>
                            </div>
                            <span
                                className="text-[10px] font-medium px-2 py-0.5 rounded-full capitalize"
                                style={{
                                    backgroundColor: `${LEAD_STATUS_COLORS[lead.status] || COLORS[0]}15`,
                                    color: LEAD_STATUS_COLORS[lead.status] || COLORS[0]
                                }}
                            >
                                {(lead.status || 'new').replace(/_/g, ' ')}
                            </span>
                        </div>
                    ))}
                </div>
            ) : (
                <p className="text-xs text-slate-400 text-center py-6">No leads yet</p>
            )}
        </div>
    );
};
